export default __webpack_public_path__ + "static/N0043-15174bedad0de8ff8dd965074c593173.png";